export const SEARCHKEY = 'video'
export const CLICK = 'click'
export const ENTER = 'Enter'
export const PLAY = 'Play'
